/** A failed API call, carrying only what resident/user-facing copy may be derived from.
 *  Generic across modules — any fetch-based client that unwraps a { data, errors } envelope
 *  can throw this instead of a module-specific *ApiError subclass. */
export class ApiResponseError extends Error {
  readonly status: number;
  readonly code: string | null;

  constructor(status: number, code: string | null) {
    super(code ?? `ApiResponseError(${status})`);
    this.name = "ApiResponseError";
    this.status = status;
    this.code = code;

    Object.setPrototypeOf(this, ApiResponseError.prototype);
  }

  /** A 409 with a server-supplied error code — the request was understood but refused by
   *  policy (e.g. capacity/registration closed), as opposed to a transport/server failure. */
  get isPolicyRefusal(): boolean {
    return this.status === 409 && this.code !== null;
  }
}
